import React from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import i18n from "./i18n";
import { LANGUAGE } from "../../redux/app/types";
import { t } from "i18next";

const LanguageOption = [
  { id: 0, name: "English", key: "en" },
  { id: 0, name: "العربية", key: "ar" },
];

const CustomLanguageSelector = () => {
  const appLanguage = useSelector((state) => state.appLanguage);
  const dispatch = useDispatch();
  const handleLanguageChange = (langKey) => {
    i18n.changeLanguage(langKey);
    dispatch({ type: LANGUAGE, payload: langKey });
  };
  return (
    <Dropdown align="end" className="LanguageSection">
      <Dropdown.Toggle variant="success" id="balance-dropdown-basic">
        {t("language")}{" "}
        {LanguageOption.find((f) => f?.key === appLanguage)?.name}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {LanguageOption.map((lang, idx) => {
          return (
            <Dropdown.Item
              key={idx}
              onClick={() => handleLanguageChange(lang.key)}
            >
              {lang.name}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomLanguageSelector;
